import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import searchService from '../../api/searchService';

// bootstrap-icon per RDC trade (best-effort; falls back to a wrench)
const ICON = (name = '') => {
  const n = name.toLowerCase();
  if (n.includes('électric') || n.includes('electric')) return 'lightning-charge';
  if (n.includes('plomb')) return 'droplet';
  if (n.includes('froid') || n.includes('climat') || n.includes('réfrig') || n.includes('frigor')) return 'snow';
  if (n.includes('dévelop') || n.includes('informat') || n.includes('réseau')) return 'code-slash';
  if (n.includes('chauffeur')) return 'truck';
  if (n.includes('méca') && n.includes('auto')) return 'car-front';
  if (n.includes('méca') && n.includes('moto')) return 'bicycle';
  if (n.includes('soud')) return 'fire';
  if (n.includes('maçon')) return 'bricks';
  if (n.includes('carrel') || n.includes('finition')) return 'grid-3x3';
  if (n.includes('menuis')) return 'hammer';
  if (n.includes('peinture')) return 'palette';
  if (n.includes('couture') || n.includes('styl')) return 'scissors';
  if (n.includes('cctv') || n.includes('caméra') || n.includes('surveillance')) return 'camera-video';
  if (n.includes('solaire')) return 'sun';
  if (n.includes('électrogène') || n.includes('générateur')) return 'plugin';
  if (n.includes('téléphone') || n.includes('mobile')) return 'phone';
  if (n.includes('pompage') || n.includes('eau')) return 'moisture';
  if (n.includes('agronom') || n.includes('jardin') || n.includes('pisci') || n.includes('apicul')) return 'flower1';
  if (n.includes('architect')) return 'building';
  if (n.includes('civil') || n.includes('btp')) return 'building-gear';
  if (n.includes('électroménager') || n.includes('appareil')) return 'plug';
  return 'wrench-adjustable';
};

export default function ServicesOverview() {
  const { t } = useTranslation();
  const [types, setTypes] = useState([]);

  useEffect(() => {
    searchService.technicianTypes().then(setTypes).catch(() => setTypes([]));
  }, []);

  return (
    <section className="section">
      <div className="container">
        <h2>{t('home.browseByTrade')}</h2>
        <p className="muted">{t('home.browseByTradeSub')}</p>
        <div className="grid cards">
          {types.map((x) => (
            <Link key={x.id} to={`/technicians?technicianTypeId=${x.id}`} className="card pad svc">
              <i className={`bi bi-${ICON(x.name)}`} />
              <span className="name">{x.name}</span>
              <span className="muted" style={{ fontSize: '.85rem' }}>{x.description}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
